/* N36 Farm Pickup interstitial
 *
 * When a cart whose "Order Type" attribute is "Store Pickup" heads to
 * checkout, show a one-tap modal telling the customer to select the
 * Pickup tab on the next screen (Shopify always lands on Ship and that
 * cannot be changed on this plan).
 *
 * FAIL-OPEN BY DESIGN: any error, missing markup, or unknown cart state
 * lets checkout proceed untouched. This script may never block a sale.
 */
(function () {
  'use strict';

  var PICKUP_VALUE = 'Store Pickup';
  var ATTR_KEY = 'Order Type';
  var cachedOrderType = null;

  /* ---- cart state ------------------------------------------------ */

  /* Optimistic window: a user press on a widget tab (see onUserPress) sets
   * the cache synchronously and opens a short window during which async
   * /cart.js refreshes may only CONFIRM the pressed value, never replace
   * it. Reason: for a second or two after the press, Stellar's own cart
   * write hasn't landed yet, so ANY fetch in that span returns the stale
   * pre-press value — and would clobber the fresh optimistic one (root
   * cause of the first-attempt misses, pinned down 2026-07-05). After the
   * window, fetched truth wins again. */
  var optimisticUntil = 0;

  function refreshOrderType() {
    try {
      fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var v = cart && cart.attributes ? cart.attributes[ATTR_KEY] : null;
          if (Date.now() < optimisticUntil && v !== cachedOrderType) return;
          cachedOrderType = v;
        })
        .catch(function () {
          if (Date.now() >= optimisticUntil) cachedOrderType = null;
        });
    } catch (e) {
      if (Date.now() >= optimisticUntil) cachedOrderType = null;
    }
  }

  refreshOrderType();

  /* Refresh the cache whenever anything mutates the cart (the Stellar
   * widget and iCart both go through these routes). */
  try {
    var origFetch = window.fetch;
    window.fetch = function () {
      var result = origFetch.apply(this, arguments);
      try {
        var url = String(
          (arguments[0] && arguments[0].url) || arguments[0] || ''
        );
        if (/\/cart\/(add|update|change|clear)/.test(url)) {
          result.then(function () { setTimeout(refreshOrderType, 300); });
        }
      } catch (e) { /* fail open */ }
      return result;
    };
  } catch (e) { /* fail open */ }

  /* Some apps use XHR rather than fetch. */
  try {
    var origOpen = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function (method, url) {
      try {
        if (/\/cart\/(add|update|change|clear)/.test(String(url))) {
          this.addEventListener('loadend', function () {
            setTimeout(refreshOrderType, 300);
          });
        }
      } catch (e) { /* fail open */ }
      return origOpen.apply(this, arguments);
    };
  } catch (e) { /* fail open */ }

  /* The Stellar widget may run inside an iframe, where the fetch/XHR hooks
   * above can never see its cart writes — the cache would then only update
   * on page load, and a customer who picks Farm Pickup and taps checkout on
   * the SAME page would sail past the modal. Assume blindness: refresh on
   * every click (the tab-tap that precedes a checkout tap, plus again a beat
   * later so the widget's own write has landed), and slow-poll while the
   * page is visible. */
  /* SYNCHRONOUS tab detection: async refreshes trail reality by ~1-2s and
   * customers click Check out faster than that (verified 2026-07-05: cart
   * attr was already "Store Pickup" at click time while the cache still
   * said "Shipping"). A click on a widget tab updates the cache INSTANTLY;
   * the polls below confirm/correct it afterwards. Note the label→value
   * mapping: the "Farm Pickup" tab writes attribute value "Store Pickup". */
  var TAB_LABEL_TO_VALUE = {
    'Farm Pickup': 'Store Pickup',
    'Store Pickup': 'Store Pickup',
    'Local Delivery': 'Local Delivery',
    'Shipping': 'Shipping'
  };
  function tabValueFromClick(el) {
    try {
      var n = el;
      for (var i = 0; i < 5 && n && n !== document.body; i++) {
        /* Signal 1: the widget's own class names (survive re-renders and
         * text quirks). Stellar tabs look like
         * "identixweb-btn-icon store-pickup-order-delivery-date". Require
         * the identixweb/order-delivery fingerprint so theme classes that
         * merely contain "shipping" can't false-match. */
        var c = String(n.className || '');
        if (/identixweb|order-delivery-date/.test(c)) {
          if (c.indexOf('store-pickup') !== -1) return 'Store Pickup';
          if (c.indexOf('local-delivery') !== -1) return 'Local Delivery';
          if (c.indexOf('shipping') !== -1) return 'Shipping';
        }
        /* Signal 2: exact label text (whitespace-normalized). */
        var t = (n.textContent || '').replace(/\s+/g, ' ').trim();
        if (t.length <= 20 &&
            Object.prototype.hasOwnProperty.call(TAB_LABEL_TO_VALUE, t)) {
          return TAB_LABEL_TO_VALUE[t];
        }
        n = n.parentElement;
      }
    } catch (e) { /* fail open */ }
    return null;
  }

  /* Detect on pointerdown/mousedown/touchstart AS WELL AS click: Stellar
   * re-renders the widget when a tab is pressed, which can retarget or
   * swallow the click event entirely — the *down* events fire on the real
   * tab element before any re-render (root cause of the first-attempt
   * misses, found 2026-07-05). */
  function onUserPress(e) {
    try {
      var tabValue = tabValueFromClick(e.target);
      if (tabValue) {
        cachedOrderType = tabValue;
        optimisticUntil = Date.now() + 5000;
      }
    } catch (err) { /* fail open */ }
  }
  /* window-level capture: fires before app handlers that stop propagation
   * of down-events lower in the tree (observed: pointer/mouse downs on the
   * Stellar tabs never reach document-level capture; only click does). */
  window.addEventListener('pointerdown', onUserPress, true);
  window.addEventListener('mousedown', onUserPress, true);
  window.addEventListener('touchstart', onUserPress, true);

  /* Debug/diagnostics hook (read-only). */
  try {
    Object.defineProperty(window, '__n36OrderTypeCache', {
      get: function () { return cachedOrderType; },
      configurable: true
    });
  } catch (e) { /* non-fatal */ }

  var lastClickRefresh = 0;
  document.addEventListener(
    'click',
    function (e) {
      try {
        onUserPress(e);
        var now = Date.now();
        if (now - lastClickRefresh < 800) return;
        lastClickRefresh = now;
        refreshOrderType();
        setTimeout(refreshOrderType, 1200);
      } catch (err) { /* fail open */ }
    },
    true
  );
  setInterval(function () {
    try {
      if (!document.hidden) refreshOrderType();
    } catch (e) { /* fail open */ }
  }, 4000);

  /* ---- modal ------------------------------------------------------ */

  function modal() {
    return document.getElementById('N36PickupInterstitial');
  }

  function placePill(m) {
    /* The white pill sits statically on the PICKUP side — highlighting the
     * option the customer needs to tap (per merchant preference; the slide
     * animation was removed 2026-07-02). Created HERE, at open time, with
     * !important inline styles — a server-rendered pill kept getting
     * suppressed by app CSS/DOM cleanup on this storefront. */
    try {
      var toggle = m.querySelector('.n36-pi-toggle');
      if (!toggle) return;
      var pill = toggle.querySelector('.n36-pi-pill');
      if (!pill) {
        pill = document.createElement('div');
        pill.className = 'n36-pi-pill';
        pill.innerHTML = '&#8203;'; /* zero-width space: never :empty */
        toggle.insertBefore(pill, toggle.firstChild);
      }
      pill.style.cssText =
        'display:block !important; visibility:visible !important;' +
        'opacity:1 !important; position:absolute; top:5px; bottom:5px;' +
        'right:5px; width:calc(50% - 7px); background:#fff;' +
        'border-radius:14px; box-shadow:0 1px 4px rgba(0,0,0,0.14);' +
        'pointer-events:none; z-index:0;';
    } catch (e) { /* non-fatal: worst case, no pill — labels still read */ }
  }

  function openModal() {
    var m = modal();
    if (!m) return false;

    /* Open in the browser TOP LAYER via <dialog>.showModal() — renders
     * above EVERY z-index on the page (iCart's drawer included); among
     * top-layer elements the last shown stacks highest, and this modal
     * always opens after the drawer. Native close (Esc) routes through
     * the 'close' event -> closeAndProceed. Old browsers without <dialog>
     * fall back to a plain fixed overlay (the visibility guard below
     * rescues them if it ends up covered). */
    if (!m.__n36CloseWired) {
      m.__n36CloseWired = true;
      try {
        m.addEventListener('close', function () { closeAndProceed(); });
      } catch (e) { /* fallback path handles closing */ }
    }
    var topLayer = false;
    try {
      if (typeof m.showModal === 'function' && !m.open) {
        m.showModal();
        topLayer = true;
      }
    } catch (e) { /* fall through to fallback */ }
    if (!topLayer) {
      try { m.setAttribute('open', ''); m.style.display = 'block'; } catch (e) { return false; }
    } else {
      /* ::backdrop already dims the page — blank our fallback overlay so
       * the dim doesn't double up. It stays in place to catch clicks. */
      try {
        var ov = m.querySelector('.n36-pi-overlay');
        if (ov) ov.style.background = 'transparent';
      } catch (e) { /* cosmetic only */ }
    }

    /* FAIL-OPEN GUARD: the modal must be THE visible, topmost thing on
     * screen — having CSS dimensions is not enough (on mobile, iCart's
     * fullscreen drawer can sit ABOVE it: sized, "visible", and completely
     * unseeable). elementFromPoint at the card's center must land on the
     * card itself; anything else — covered, off-viewport, suppressed —
     * means the customer would be stranded behind an invisible modal, so
     * send them straight to checkout instead. */
    try {
      requestAnimationFrame(function () {
        try {
          var card = m.querySelector('.n36-pi-card');
          if (!card) return closeAndProceed();
          var r = card.getBoundingClientRect();
          var vw = window.innerWidth || 0;
          var vh = window.innerHeight || 0;
          var inViewport =
            r.width > 10 && r.height > 10 &&
            r.bottom > 0 && r.right > 0 && r.top < vh && r.left < vw;
          if (!inViewport) return closeAndProceed();
          if (window.getComputedStyle(card).visibility === 'hidden') {
            return closeAndProceed();
          }
          var cx = Math.max(0, Math.min(vw - 1, r.left + r.width / 2));
          var cy = Math.max(0, Math.min(vh - 1, r.top + r.height / 2));
          var top = document.elementFromPoint(cx, cy);
          if (!top || !(top === card || card.contains(top))) {
            return closeAndProceed();
          }
        } catch (e) { /* verification failed -> leave the modal up */ }
      });
    } catch (e) { /* no rAF -> leave the modal up */ }

    placePill(m);
    try {
      var btn = document.getElementById('N36PickupContinue');
      if (btn) btn.focus();
    } catch (e) { /* non-fatal */ }
    return true;
  }

  var proceeding = false;
  function closeAndProceed() {
    /* Navigate straight to checkout. Deliberately NOT a synthetic re-click
     * of the original button: app handlers (iCart, esp. on mobile) may
     * ignore untrusted clicks, which would strand the customer. A direct
     * /checkout navigation works from any cart state on any device. */
    if (proceeding) return;
    proceeding = true;
    var m = modal();
    try {
      if (m && typeof m.close === 'function' && m.open) m.close();
      else if (m) { m.removeAttribute('open'); m.style.display = 'none'; }
    } catch (e) {
      try { if (m) { m.removeAttribute('open'); m.style.display = 'none'; } } catch (e2) { /* proceed anyway */ }
    }
    try {
      window.location.href = '/checkout';
    } catch (e) { /* nothing further we can do */ }
  }

  /* ---- interception ----------------------------------------------- */

  function findCheckoutTrigger(el) {
    if (!el || !el.closest) return null;
    /* Covers the theme drawer, cart page, cart notification, and — by
     * class pattern — app-rendered buttons (iCart renders its own drawer
     * at runtime on the live theme only, so it cannot be exercised on a
     * preview theme; verify on launch). Constrained to button/a elements
     * so a checkout-named wrapper can never swallow unrelated clicks. */
    return el.closest(
      'button[name="checkout"], input[name="checkout"], ' +
      'a[href*="/checkout"], #CartDrawer-Checkout, #checkout, ' +
      'button[class*="checkout" i], a[class*="checkout" i]'
    );
  }

  document.addEventListener(
    'click',
    function (e) {
      try {
        var m = modal();
        if (m && m.open) return; /* modal already up: let its own handlers work */
        var trigger = findCheckoutTrigger(e.target);
        if (!trigger) return;
        /* Only intercept when we positively know it is a pickup cart. */
        if (cachedOrderType !== PICKUP_VALUE) return;
        if (!m) return; /* markup missing -> fail open */
        e.preventDefault();
        e.stopImmediatePropagation();
        openModal();
      } catch (err) { /* fail open */ }
    },
    true
  );

  /* Continue button, overlay click, and Escape all proceed to checkout —
   * the modal can slow a customer down by exactly one tap, never stop them. */
  document.addEventListener('click', function (e) {
    try {
      var m = modal();
      if (!m || !m.open) return;
      if (
        e.target.id === 'N36PickupContinue' ||
        e.target.closest('#N36PickupContinue') ||
        e.target.classList.contains('n36-pi-overlay')
      ) {
        e.preventDefault();
        closeAndProceed();
      }
    } catch (err) { /* fail open */ }
  });

  document.addEventListener('keydown', function (e) {
    try {
      var m = modal();
      if (!m || !m.open) return;
      if (e.key === 'Escape') closeAndProceed();
    } catch (err) { /* fail open */ }
  });
})();
